<template>
  <DefaultTemplate>
    <div class="pd-x-2 pd-y-1">
      <Header title="" />
      <div class="box-success">
        <i class="fas fa-check-circle color-success text-font-80"></i>
        <p class="mg-y-4 text-font-24">คุณ{{ nameTh }} {{ lastNameTh }}</p>
        <h1 class="color-success mg-y-5 text-font-36">
          ลงทะเบียนเรียนออนไลน์เรียบร้อยแล้ว!
        </h1>

        <p class="pd-t-1 text-font-18">กรุณาเข้าสู่ระบบเรียนออนไลน์ เพื่อลงทะเบียนเรียนหลักสูตร</p>
        <el-button
          @click="$router.push('/signin')"
          round
          type="primary"
          class=" pd-x-1  text-font-16 button-auth"
          >เข้าสู่ระบบเรียนออนไลน์</el-button
        >
      </div>
    </div>
  </DefaultTemplate>
</template>

<script>
import DefaultTemplate from "@/template/DefaultTemplate";
import Header from "@/components/template/Header";

export default {
  components: {
    DefaultTemplate,
    Header,
  },
  props: {
    nameTh: {
      type: String,
      default() {
        return "";
      },
    },
    lastNameTh: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.box-success {
  padding: 5vh 0 5vh 0;
}
.text-font-80 {
  font-size: 80px;
}
</style>
